module.exports = {
      id: "warning-usage",
      viewBox: "0 0 75 75",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#warning-usage",
      toString: function () {
        return this.url;
      }
    }